import { jsx as _jsx } from "react/jsx-runtime";
import { ReadonlyText } from "./GlobalAdminUserFormBase.styles";
import { HXTextField } from "../base.styles";
export const EditableText = (props) => {
    const { editable, ...textFieldProps } = props;
    if (editable) {
        return _jsx(HXTextField, { ...textFieldProps });
    }
    else {
        return _jsx(ReadonlyText, { children: String(props.value) });
    }
};
